import api from '@/services/api/api';

export const useHistoricalMaps = (filters = {}) => {
  const historicalMaps = useQuery(
    ['historicalMaps', filters],
    async () => {
      const { data } = await api.maps.getHistoricalMaps(toValue(filters));
      return data;
    },
    { select: ({ data }) => data },
  );

  onServerPrefetch(async () => {
    await historicalMaps.suspense();
  });

  return {
    historicalMaps,
  };
};
